import Cookies from 'js-cookie';

const user = {
  state: {
  },
  mutations: {

  }
};

export default user;



// WEBPACK FOOTER //
// ./src/config/store/modules/user.js